// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModeleSouscription = (value) => ({
  type: actionTypes.SET_VALUE_ModeleSouscription,
  payload: value,
});

export const setTypeModeleSouscription = (type) => ({
  type: actionTypes.SET_TYPE_ModeleSouscription,
  payload: type,
});
export const setActifModeleSouscription = (actif) => ({
  type: actionTypes.SET_ACTIF_ModeleSouscription,
  payload: actif,
});

export const setCurrentPageModeleSouscription = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModeleSouscription,
  payload: page,
});

export const setOrderModeleSouscription = (order) => ({
  type: actionTypes.SET_ORDER_ModeleSouscription,
  payload: order,
});

export const setSortFieldModeleSouscription = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModeleSouscription,
  payload: field,
});
export const setCategorieModeleSouscription = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModeleSouscription,
  payload: categorie,
});
